import {
  AZURE_APPLICATION_CLIENT_ID,
  AZURE_AUTHORITY_HOST,
  AZURE_REDIRECT_URI,
  AZURE_TENANT_ID,
} from '../../envConfig'

export const msalConfig = {
  auth: {
    clientId: AZURE_APPLICATION_CLIENT_ID,
    authority: `${AZURE_AUTHORITY_HOST}/${AZURE_TENANT_ID}`,
    redirectUri: AZURE_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  isConfiguredProperly: !!(
    AZURE_APPLICATION_CLIENT_ID &&
    AZURE_AUTHORITY_HOST &&
    AZURE_REDIRECT_URI &&
    AZURE_TENANT_ID
  ),
}

export const loginRequest = {
  scopes: ['User.Read'],
}
